import { clouds, products } from "../../../../src/products";
import * as React from 'react';
export default {
  clouds,
  products,
  React
};